import '@sass/components/sweet-alert.scss';
import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

/**
 * Alert User with a popup containing text and an OK button.
 *
 * Common Usage:
 * await createAlertDialog({
 *   titleText: 'This action has been disabled',
 *   text: 'Sorry, this feature has been disabled due to insufficient funds in your account.',
 * });
 */
export function createAlertDialog(options?: SweetAlertOptions): Promise<SweetAlertResult<any>> {
  const defaults = {
    buttonsStyling: false,
    allowOutsideClick: false,
    customClass: {
      confirmButton: 'btn btn-primary mr-5',
      cancelButton: 'btn',
      popup: 'sweet-alert-popup',
      title: 'sweet-alert-header',
      actions: 'sweet-alert-actions',
    },
  };

  return Swal.fire({
    ...defaults,
    ...options,
  });
}

/**
 * Check whether any confirmation dialog is currently visible.
 */
export const isConfirmDialogVisible = () => Swal.isVisible();
